import { Menu, MenuProps } from "antd"
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom"
import { SystemConfigState } from "../../../redux/systemConfigSlicer";
import { DesktopOutlined, FileImageOutlined, PieChartOutlined, QrcodeOutlined, UserOutlined, UserAddOutlined, ShopOutlined, MailOutlined } from "@ant-design/icons";
import React from "react";
import { RootState } from '../../../redux/appState';
import { isRootUser } from "../../App";

export { };

type MenuItem = Required<MenuProps>['items'][number];

const PrivateMenu = () => {
  const location = useLocation();
  const theme = useSelector((state: { systemConfig: SystemConfigState }) => state.systemConfig.theme);
  const user = useSelector((state: RootState) => state.user.user);

  const menuItems: { [key: string]: string } = {
    '/': '1',
    '/home': '1',
    '/dashboard': '1',
    '/events': '2',
    '/users': '3',
    '/qrcode-generator': '4',
    '/placards': '5',
    '/dealers': '6',
    '/onboarding': '7',
    '/inventoryMgmt': '8',
    '/contracts': '9',
    '/admin/orders': '11',
    '/admin/emails': '12',
    '/admin/client-properties': '13',
  };
  if (location.pathname.startsWith('/events/')) {
    menuItems[location.pathname] = '2';
  }
  const defaultSelectedKey = menuItems[location.pathname] || '1';
  const hiddenCondition = () => {
    return !isRootUser(user);
  }

  const items: MenuItem[] = [
    {
      key: '1',
      icon: <PieChartOutlined />,
      label: <Link to="/dashboard">Dashboard</Link>,
    },
    ...(!hiddenCondition() ? [
      {
        key: '4',
        icon: <QrcodeOutlined />,
        label: <Link to="/qrcode-generator">QRcode generator</Link>,
      },
    ] as MenuItem[] : []),
    {
      key: '5',
      icon: <FileImageOutlined />,
      label: <Link to="/placards">Placards</Link>,
    },
    {
      key: '8',
      icon: <ShopOutlined />,
      label: <Link to="/inventoryMgmt">Manage Inventory</Link>,
    },
    ...(!hiddenCondition() ? [
      {
        key: 'admin-category',
        label: <span style={{ color: 'rgba(255, 255, 255, 0.45)', fontWeight: 'bold', fontSize: '12px' }}>ADMIN</span>,
        type: 'group' as const,
        children: [
          {
            key: '2',
            icon: <DesktopOutlined />,
            label: <Link to="/events">Events</Link>,
          },
          {
            key: '3',
            icon: <UserOutlined />,
            label: <Link to="/users">Users</Link>,
          },
          {
            key: '6',
            icon: <UserOutlined />,
            label: <Link to="/dealers">Dealers</Link>,
          },
          {
            key: '7',
            icon: <UserAddOutlined />,
            label: <Link to="/onboarding">Onboarding</Link>,
          },
          {
            key: '9',
            icon: <UserOutlined />,
            label: <Link to="/contracts">Contracts</Link>,
          },
          {
            key: '11',
            icon: <ShopOutlined />,
            label: <Link to="/admin/orders">Orders</Link>,
          },
          {
            key: '12',
            icon: <MailOutlined />,
            label: <Link to="/admin/emails">Emails</Link>,
          },
          {
            key: '13',
            icon: <FileImageOutlined />,
            label: <Link to="/admin/client-properties">Client Properties</Link>,
          },
        ]
      } as MenuItem,
    ] as MenuItem[] : []),
  ];
  return (
    <Menu theme={theme} selectedKeys={[defaultSelectedKey]} mode="inline" items={items} />
  );
}

export default PrivateMenu;